import styled from 'styled-components';

export const ContainerClients = styled.div`
  padding: var(--spacing-3xl) var(--spacing-xl);
  min-height: calc(100vh - 200px);
  background-color: var(--bg-main);
  margin: 0;

  .page-header {
    margin-bottom: var(--spacing-3xl);
    
    h2 {
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      margin-bottom: var(--spacing-sm);
      font-size: var(--font-size-2xl);
    }
    
    p {
      font-size: var(--font-size-lg);
      margin-bottom: 0;
      color: var(--text-secondary);
    }
  }

  .form-section {
    background: var(--bg-light);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-2xl);
    margin-bottom: var(--spacing-2xl);
    box-shadow: var(--shadow-md);
    border: none;
  }

  table {
    margin-bottom: 0;
    font-size: var(--font-size-sm) !important;

    th {
      background-color: var(--gray-100);
      border-top: none;
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      padding: var(--spacing-lg);
    }

    td {
      padding: var(--spacing-lg);
      vertical-align: middle;
      color: var(--text-muted);
      border-color: var(--gray-200);
    }

    tbody tr:hover {
      background-color: var(--gray-100);
    }
  }

  .filter {
    display: flex;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-lg);
  }

  th:nth-of-type(2) {
    width: 20vw;
  }
  th:nth-of-type(3) {
    width: 10vw;
  }
  th:nth-of-type(4) {
    width: 10vw;
  }
  
  @media (max-width: 1180px) {
    width: 100%;
    float: none !important;
    margin-left: 0px !important;
    padding: var(--spacing-md);
  }
`;

export const ContainerAddress = styled.div`
  background-position: top center;
  background-repeat: repeat;
  padding-bottom: var(--spacing-4xl);
  background-color: var(--bg-light);

  .container {
    background-color: var(--bg-white);
    padding: var(--spacing-lg);
    border-radius: var(--border-radius-lg);
    box-shadow: var(--shadow-sm);
  }

  input {
    margin: var(--spacing-sm) 0px var(--spacing-sm) 0px !important;
    border-color: var(--gray-300);
    border-radius: var(--border-radius-md);
    
    &:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 0 0.2rem rgba(var(--primary-color-rgb), 0.25);
    }
  }

  .loginDiv {
    padding: var(--spacing-lg);
  }

  .menuUser p {
    transition: var(--transition-base);
    margin-top: var(--spacing-sm);
    padding: var(--spacing-sm);
    background: var(--gray-100);
    border-radius: var(--border-radius-md);
    color: var(--text-secondary);
  }

  .menuUser {
    transition: var(--transition-base);
    cursor: pointer;
  }

  .menuUser :hover {
    transition: var(--transition-base);
    margin-left: var(--spacing-sm);

    a {
      margin: 0px !important;
    }
  }

  .checkTerms {
    display: flex;
    align-items: center;

    label {
      margin-left: var(--spacing-sm);
      margin-bottom: -2px;
      color: var(--text-secondary);
    }
  }

  input,
  select {
    margin-bottom: var(--spacing-lg) !important;
  }

  .addressCard {
    box-shadow: var(--shadow-md);
    padding: var(--spacing-lg);
    border-radius: var(--border-radius-lg);
    margin-top: var(--spacing-lg);
    background-color: var(--bg-white);
    border: 1px solid var(--gray-200);
  }

  .actionBtn {
    cursor: pointer;
    margin: var(--spacing-sm);
    font-size: var(--font-size-xl);
    color: var(--primary-color);
    transition: var(--transition-base);

    &:hover {
      color: var(--primary-dark);
      transform: scale(1.1);
    }
  }
`;

export const Title = styled.h2`
  padding-top: var(--spacing-lg);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  color: var(--text-primary);

  svg {
    margin-right: var(--spacing-sm);
    font-size: var(--font-size-lg);
    margin-bottom: var(--spacing-xs);
    color: var(--primary-color);
  }
`;

export const ContainerLoading = styled.div`
  height: calc(100vh - 7.5rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-light);

  h1 {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    color: var(--primary-color);
    text-align: center;
    margin-top: var(--spacing-lg);
  }
`;
